/** @format */

import {
  GET_ABOUTME_SUCCESS,
  GET_ABOUTME_FAIL,
  GET_ABOUTME_REQUEST,
  GET_PROJECTS_REQUEST,
  GET_PROJECTS_SUCCESS,
  GET_PROJECTS_FAIL,
  GET_WEB_PROJECTS_REQUEST,
  GET_WEB_PROJECTS_SUCCESS,
  GET_WEB_PROJECTS_FAIL,
  GET_MOBILE_PROJECTS_REQUEST,
  GET_MOBILE_PROJECTS_SUCCESS,
  GET_MOBILE_PROJECTS_FAIL,
  GET_API_PROJECTS_REQUEST,
  GET_API_PROJECTS_SUCCESS,
  GET_API_PROJECTS_FAIL,
  GET_UI_PROJECTS_SUCCESS,
  GET_UI_PROJECTS_FAIL,
  GET_OTHER_PROJECTS_REQUEST,
  GET_OTHER_PROJECTS_SUCCESS,
  GET_OTHER_PROJECTS_FAIL,
  GET_UI_PROJECTS_REQUEST,
  POST_COMMENT_FAIL,
  POST_COMMENT_SUCCESS,
  POST_COMMENT_REQUEST,
  GET_SOCIALLINKS_SUCCESS,
  GET_SOCIALLINKS_REQUEST,
  GET_SOCIALLINKS_FAIL,
  GET_TimeStamp_REQUEST,
  GET_TimeStamp_SUCCESS,
  GET_TimeStamp_FAIL,
  GET_CERTIFICATE_REQUEST,
  GET_CERTIFICATE_SUCCESS,
  GET_CERTIFICATE_FAIL,
} from "../constants/notesConstants";
import axios from "axios";
import { toast } from "wc-toast";
import url from "../settings/settings.json";

export const getAboutMe = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_ABOUTME_REQUEST,
    });

    // const {
    //   userLogin: { userInfo },
    // } = getState();

    // const config = {
    //   headers: {
    //     Authorization: `Bearer ${userInfo?.token}`,
    //   },
    // };
    // https://portfolio-api-v001.vercel.app/api/aboutme/public/

    const { data } = await axios.get(
      "https://portfolio-api-v001.vercel.app/api/aboutme/public/64d8ace7233c63d92a59a7c3"
    );
    // const { data } = await axios.get(url.API_URI + "aboutme");
    console.log(data);

    dispatch({
      type: GET_ABOUTME_SUCCESS,
      payload: data.length ? data[0] : data,
    });

    toast.success("Get Data success", { duration: 4000 });
  } catch (error) {
    let message = "";

    if (error.response) {
      if (error.response.data) {
        if (error.response.data.msg) {
          if (error.response.data.msg.message) {
            message = error.response.data.msg.message;
            console.log(error.response.data.msg.message);
          } else {
            message = error.response.data.msg;
          }
        } else {
          message = error.response.data;
        }
      } else {
        message = error.response;
      }
    } else {
      message = error.message;
    }

    dispatch({
      type: GET_ABOUTME_FAIL,
      payload: message,
    });

    toast.error(message, { duration: 4000 });
    // console.log(error);
  }
};

export const getProjects = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_WEB_PROJECTS_REQUEST,
    });
    const { data } = await axios.get(url.API_URI + "project/web");
    console.log(data);

    dispatch({
      type: GET_WEB_PROJECTS_SUCCESS,
      payload: data,
    });

    toast.success("Get Data success", { duration: 4000 });
  } catch (error) {
    let message = "";

    if (error.response) {
      if (error.response.data) {
        if (error.response.data.msg) {
          if (error.response.data.msg.message) {
            message = error.response.data.msg.message;
            console.log(error.response.data.msg.message);
          } else {
            message = error.response.data.msg;
          }
        } else {
          message = error.response.data;
        }
      } else {
        message = error.response;
      }
    } else {
      message = error.message;
    }

    dispatch({
      type: GET_WEB_PROJECTS_FAIL,
      payload: message,
    });

    toast.error(message, { duration: 4000 });
    // console.log(error);
  }
};

// get projects

export const getWebProjects = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_WEB_PROJECTS_REQUEST,
    });
    const { data } = await axios.get(
      "https://portfolio-api-v001.vercel.app/api/project/64d8ace7233c63d92a59a7c3/active"
      // url.API_URI + "project/web"
    );
    console.log(data);

    dispatch({
      type: GET_WEB_PROJECTS_SUCCESS,
      payload: data[0] ? data[0].projects : data,
    });

    toast.success("Get Data success", { duration: 4000 });
  } catch (error) {
    let message = "";

    if (error.response) {
      if (error.response.data) {
        if (error.response.data.msg) {
          if (error.response.data.msg.message) {
            message = error.response.data.msg.message;
            console.log(error.response.data.msg.message);
          } else {
            message = error.response.data.msg;
          }
        } else {
          message = error.response.data;
        }
      } else {
        message = error.response;
      }
    } else {
      message = error.message;
    }

    dispatch({
      type: GET_WEB_PROJECTS_FAIL,
      payload: message,
    });

    toast.error(message, { duration: 4000 });
    // console.log(error);
  }
};

export const getCertificate = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_CERTIFICATE_REQUEST,
    });
    const { data } = await axios.get(
      "https://portfolio-api-v001.vercel.app/api/certificate/64d8ace7233c63d92a59a7c3/active"
      // url.API_URI + "project/web"
    );
    console.log(data);

    dispatch({
      type: GET_CERTIFICATE_SUCCESS,
      payload: data,
    });

    toast.success("Get Data success", { duration: 4000 });
  } catch (error) {
    let message = "";

    if (error.response) {
      if (error.response.data) {
        if (error.response.data.msg) {
          if (error.response.data.msg.message) {
            message = error.response.data.msg.message;
            console.log(error.response.data.msg.message);
          } else {
            message = error.response.data.msg;
          }
        } else {
          message = error.response.data;
        }
      } else {
        message = error.response;
      }
    } else {
      message = error.message;
    }

    dispatch({
      type: GET_CERTIFICATE_FAIL,
      payload: message,
    });

    toast.error(message, { duration: 4000 });
    // console.log(error);
  }
};

// get projects

export const getMobileProjects = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_MOBILE_PROJECTS_REQUEST,
    });
    const { data } = await axios.get(url.API_URI + "project/mobile");
    console.log(data);

    dispatch({
      type: GET_MOBILE_PROJECTS_SUCCESS,
      payload: data,
    });

    toast.success("Get Data success", { duration: 4000 });
  } catch (error) {
    let message = "";

    if (error.response) {
      if (error.response.data) {
        if (error.response.data.msg) {
          if (error.response.data.msg.message) {
            message = error.response.data.msg.message;
            console.log(error.response.data.msg.message);
          } else {
            message = error.response.data.msg;
          }
        } else {
          message = error.response.data;
        }
      } else {
        message = error.response;
      }
    } else {
      message = error.message;
    }

    dispatch({
      type: GET_MOBILE_PROJECTS_FAIL,
      payload: message,
    });

    toast.error(message, { duration: 4000 });
    // console.log(error);
  }
};

// get projects

export const getApiProjects = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_API_PROJECTS_REQUEST,
    });
    const { data } = await axios.get(url.API_URI + "project/api");
    console.log(data);

    dispatch({
      type: GET_API_PROJECTS_SUCCESS,
      payload: data,
    });

    toast.success("Get Data success", { duration: 4000 });
  } catch (error) {
    let message = "";

    if (error.response) {
      if (error.response.data) {
        if (error.response.data.msg) {
          if (error.response.data.msg.message) {
            message = error.response.data.msg.message;
            console.log(error.response.data.msg.message);
          } else {
            message = error.response.data.msg;
          }
        } else {
          message = error.response.data;
        }
      } else {
        message = error.response;
      }
    } else {
      message = error.message;
    }

    dispatch({
      type: GET_API_PROJECTS_FAIL,
      payload: message,
    });

    toast.error(message, { duration: 4000 });
    // console.log(error);
  }
};

// get projects

export const getUiProjects = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_UI_PROJECTS_REQUEST,
    });
    const { data } = await axios.get(url.API_URI + "project/ui");
    console.log(data);

    dispatch({
      type: GET_UI_PROJECTS_SUCCESS,
      payload: data,
    });

    toast.success("Get Data success", { duration: 4000 });
  } catch (error) {
    let message = "";

    if (error.response) {
      if (error.response.data) {
        if (error.response.data.msg) {
          if (error.response.data.msg.message) {
            message = error.response.data.msg.message;
            console.log(error.response.data.msg.message);
          } else {
            message = error.response.data.msg;
          }
        } else {
          message = error.response.data;
        }
      } else {
        message = error.response;
      }
    } else {
      message = error.message;
    }

    dispatch({
      type: GET_UI_PROJECTS_FAIL,
      payload: message,
    });

    toast.error(message, { duration: 4000 });
    // console.log(error);
  }
};

// get projects

export const getOtherProjects = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_OTHER_PROJECTS_REQUEST,
    });
    const { data } = await axios.get(url.API_URI + "project/other");
    console.log(data);

    dispatch({
      type: GET_OTHER_PROJECTS_SUCCESS,
      payload: data,
    });

    toast.success("Get Data success", { duration: 4000 });
  } catch (error) {
    let message = "";

    if (error.response) {
      if (error.response.data) {
        if (error.response.data.msg) {
          if (error.response.data.msg.message) {
            message = error.response.data.msg.message;
            console.log(error.response.data.msg.message);
          } else {
            message = error.response.data.msg;
          }
        } else {
          message = error.response.data;
        }
      } else {
        message = error.response;
      }
    } else {
      message = error.message;
    }

    dispatch({
      type: GET_OTHER_PROJECTS_FAIL,
      payload: message,
    });

    toast.error(message, { duration: 4000 });
    // console.log(error);
  }
};

// get projects

export const addComment =
  (fullName, email, comments) => async (dispatch, getState) => {
    try {
      dispatch({
        type: POST_COMMENT_REQUEST,
      });
      toast.loading("Loading ...", { duration: 3000 });

      const { data } = await axios.post(url.API_URI + "comment", {
        fullName,
        email,
        comments,
      });
      console.log(data);

      dispatch({
        type: POST_COMMENT_SUCCESS,
        payload: data,
      });

      toast.success("Comment Submited successfully", { duration: 3000 });
    } catch (error) {
      let message = "";
      // console.log(error.response.data[0].errors.email.message);
      if (error.response) {
        if (error.response.data) {
          if (error.response.data[0]) {
            if (error.response.data[0].errors.fullName?.message) {
              message = error.response.data[0].errors.fullName?.message;
            } else if (error.response.data[0].errors.email?.message) {
              message = error.response.data[0].errors.email?.message;
            } else if (error.response.data[0].errors.comments?.message) {
              message = error.response.data[0].errors.comments?.message;
            }
          } else if (error.response.data.msg) {
            if (error.response.data.msg.message) {
              message = error.response.data.msg.message;
              console.log(error.response.data.msg.message);
            } else {
              message = error.response.data.msg;
            }
          } else {
            message = error.response.data;
          }
        } else {
          message = error.response;
        }
      } else {
        message = error.message;
      }

      dispatch({
        type: POST_COMMENT_FAIL,
        payload: message,
      });

      toast.error(message, { duration: 4000 });
      // console.log(error);
    }
  };

// / get projects

export const getSocialLinks = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_SOCIALLINKS_REQUEST,
    });
    toast.loading("Loading ...", { duration: 3000 });

    const { data } = await axios.get(
      "https://portfolio-api-v001.vercel.app/api/socialLinks/active/64d8ace7233c63d92a59a7c3"
    );
    // const { data } = await axios.get(url.API_URI + "socialLinks");
    console.log(data);

    dispatch({
      type: GET_SOCIALLINKS_SUCCESS,
      payload: data,
    });

    // toast.success("Comment Submited successfully", { duration: 3000 });
  } catch (error) {
    let message = "";
    // console.log(error.response.data[0].errors.email.message);
    if (error.response) {
      if (error.response.data) {
        if (error.response.data[0]) {
          if (error.response.data[0].errors.fullName?.message) {
            message = error.response.data[0].errors.fullName?.message;
          } else if (error.response.data[0].errors.email?.message) {
            message = error.response.data[0].errors.email?.message;
          } else if (error.response.data[0].errors.comments?.message) {
            message = error.response.data[0].errors.comments?.message;
          }
        } else if (error.response.data.msg) {
          if (error.response.data.msg.message) {
            message = error.response.data.msg.message;
            console.log(error.response.data.msg.message);
          } else {
            message = error.response.data.msg;
          }
        } else {
          message = error.response.data;
        }
      } else {
        message = error.response;
      }
    } else {
      message = error.message;
    }

    dispatch({
      type: GET_SOCIALLINKS_FAIL,
      payload: message,
    });

    toast.error(message, { duration: 4000 });
    // console.log(error);
  }
};

// / get projects

export const getTimeStamps = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_TimeStamp_REQUEST,
    });
    toast.loading("Loading ...", { duration: 3000 });

    const { data } = await axios.get(
      "https://portfolio-api-v001.vercel.app/api/getupdates/64d8ace7233c63d92a59a7c3"
    );
    console.log(data.length ? data[0] : data);

    dispatch({
      type: GET_TimeStamp_SUCCESS,
      payload: data.length ? data[0] : data,
    });

    // toast.success("Comment Submited successfully", { duration: 3000 });
  } catch (error) {
    let message = "";
    // console.log(error.response.data[0].errors.email.message);
    if (error.response) {
      if (error.response.data) {
        if (error.response.data[0]) {
          if (error.response.data[0].errors.fullName?.message) {
            message = error.response.data[0].errors.fullName?.message;
          } else if (error.response.data[0].errors.email?.message) {
            message = error.response.data[0].errors.email?.message;
          } else if (error.response.data[0].errors.comments?.message) {
            message = error.response.data[0].errors.comments?.message;
          }
        } else if (error.response.data.msg) {
          if (error.response.data.msg.message) {
            message = error.response.data.msg.message;
            console.log(error.response.data.msg.message);
          } else {
            message = error.response.data.msg;
          }
        } else {
          message = error.response.data;
        }
      } else {
        message = error.response;
      }
    } else {
      message = error.message;
    }

    dispatch({
      type: GET_TimeStamp_FAIL,
      payload: message,
    });

    toast.error(message, { duration: 4000 });
    // console.log(error);
  }
};
